function inlineFilterItems(instance) {
  return [
    {
      id: 'all',
      label: instance.$t('fleetTask.status.all'),
    },
    {
      id: 'DRAFT',
      label: instance.$t('fleetTask.status.draft'),
    },
    {
      id: 'SCHEDULED',
      label: instance.$t('fleetTask.status.scheduled'),
    },
    {
      id: 'STARTED',
      label: instance.$t('fleetTask.status.started'),
    },
    {
      id: 'ENDED',
      label: instance.$t('fleetTask.status.ended'),
    },
    {
      id: 'CANCELED',
      label: instance.$t('fleetTask.status.canceled'),
    },
  ]
}

export default inlineFilterItems
